
<template>
     <div class="dashboard-container">
        <component :is="currentRole" v-on:handleLogin="handleLogin" ref="login"/>
    </div>
</template>

<script>
    import loginIndex from './Login/index'
    import yianLogin from './Login/yianLogin'
    import {setToken} from '@/utils/auth'
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Login',
        data() {
            return {
                currentRole: 'loginIndex',
                //配置登录页面
                currentValue:{
                  'visual.ltylao.com':'loginIndex',
                  'yian.visual.ltylao.com':'yianLogin',
                },
                redirect: undefined,
            }
        },
        components:{
            loginIndex,yianLogin
        },
        created(){
          let host=window.location.host
          if(this.currentValue[host]){
            this.currentRole=this.currentValue[host]
          }
        },
        watch: {
          $route: {
              handler: function(route) {
                  this.redirect = route.query && route.query.redirect
              },
              immediate: true
          }
        },
        methods: {
            handleLogin(loginForm) {
              this.$axios({
                  method: 'post',
                  url: this.$visualizationUrl+'VisualAccount/Login',
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      loginName:loginForm.username,
                      password:loginForm.password
                  }
              }).then( (response)=> {
                  this.$refs.login.loading=false
                  if(response.data.error == 0){
                      setToken(response.data.data)
                      this.$router.push({ path: this.redirect || '/' })
                  }else if(response.data.error == 1){
                      this.$message({type: 'error', message: response.data.message});
                  }
                })
            },
        }
    }

</script>

<style lang="scss" scoped>
    .dashboard-container{
        height: 100vh;
    }
</style>
